export type PosStorageDurability = "PERSISTED" | "BEST_EFFORT" | "UNSUPPORTED";

type BrowserStorageManager = {
  persist?: () => Promise<boolean>;
  persisted?: () => Promise<boolean>;
};

let persistenceAttempt: Promise<PosStorageDurability> | null = null;

function storageManager(): BrowserStorageManager | null {
  if (typeof navigator === "undefined" || !navigator.storage) return null;
  return navigator.storage as BrowserStorageManager;
}

export async function readPosStorageDurability(): Promise<PosStorageDurability> {
  const storage = storageManager();
  if (!storage?.persisted) return storage?.persist ? "BEST_EFFORT" : "UNSUPPORTED";

  try {
    return (await storage.persisted()) ? "PERSISTED" : "BEST_EFFORT";
  } catch {
    return storage.persist ? "BEST_EFFORT" : "UNSUPPORTED";
  }
}

export function ensurePosStoragePersistent(): Promise<PosStorageDurability> {
  if (persistenceAttempt) return persistenceAttempt;

  persistenceAttempt = (async () => {
    const storage = storageManager();
    if (!storage?.persist) return "UNSUPPORTED";

    try {
      if (storage.persisted && await storage.persisted()) return "PERSISTED";
      return (await storage.persist()) ? "PERSISTED" : "BEST_EFFORT";
    } catch {
      return "BEST_EFFORT";
    }
  })();

  return persistenceAttempt;
}
